function scrollCarousel(direction) {
    const carousel = document.querySelector(".size-guide-carousel");
    const slideWidth = document.querySelector(".size-guide-slide").offsetWidth;
    carousel.scrollBy({ left: direction * slideWidth, behavior: "smooth" });
}

//Modal code:
document.addEventListener("DOMContentLoaded", function () {
const modal = document.getElementById("sizeGuideModal");
const modalMedia = document.getElementById("sizeGuideModalMedia");
const closeModal = document.getElementById("sizeGuideModalClose");
const prevButton = document.getElementById("sizeGuideModalPrev");
const nextButton = document.getElementById("sizeGuideModalNext");


const slides = document.querySelectorAll(".size-guide-slide");
    const prevArrow = document.querySelector(".left-arrow");
    const nextArrow = document.querySelector(".right-arrow");
    const modalSlides = document.querySelectorAll(".size-guide-modal__image"); // Adjust selector if needed
    const modalPrevArrow = document.getElementById("sizeGuideModalPrev");
    const modalNextArrow = document.getElementById("sizeGuideModalNext");


    if (slides.length > 1) {
        prevArrow.style.display = "block";
        nextArrow.style.display = "block";
        modalPrevArrow.style.display = "block";
        modalNextArrow.style.display = "block";
    }

//Preloads initial modal image when drawer opens:

const sizeGuideDrawerContainer = Array.from(document.querySelectorAll(".drawer-container")).find(container =>
    container.querySelector(".size-guide-content")
);

if (!sizeGuideDrawerContainer) {
    console.log("❌ Size guide drawer-container not found.");
    return;
}


const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        if (mutation.attributeName === "class") {
            if (sizeGuideDrawerContainer.classList.contains("open")) {
                const firstThumbnail = document.querySelector(".size-guide-thumbnail");
                if (firstThumbnail) {
                    const firstImage = new Image();
                    firstImage.src = firstThumbnail.getAttribute("data-external-media");
                }
            }
        }
    });
});

observer.observe(sizeGuideDrawerContainer, { attributes: true });


let startX = 0;
let endX = 0;
let sizeGuideImages = [];
let sizeGuideCaptions = [];
let currentIndex = 0;

if (!modal || !modalMedia || !closeModal || !prevButton || !nextButton) {
console.error(" Modal elements not found in DOM.");
return;
}


console.log(" size-guide.js is loaded.");

function openSizeGuideModal(event) {
const thumbnails = Array.from(document.querySelectorAll(".size-guide-thumbnail"));
sizeGuideImages = thumbnails.map(img => img.getAttribute("data-external-media"));
sizeGuideCaptions = thumbnails.map(img => img.nextElementSibling?.textContent?.trim() || "");

currentIndex = thumbnails.indexOf(this);
if (currentIndex === -1) return;

updateModalContent();
modal.classList.add("is-open");
}

function lazyLoadNextImage(index) {
    if (index + 1 < sizeGuideImages.length) {
        const nextImage = new Image();
        nextImage.src = sizeGuideImages[index + 1];
    }
}


function updateModalContent() {
if (sizeGuideImages.length === 0) return;
const mediaSrc = sizeGuideImages[currentIndex];
const captionText = sizeGuideCaptions[currentIndex] || "";

modalMedia.innerHTML = `
<img src="${mediaSrc}" class="size-guide-modal__image" alt="Size Guide">
<h3 class="size-guide-modal__caption">${captionText}</h3>
`;

lazyLoadNextImage(currentIndex);
}




function showNextImage(event) {
if (sizeGuideImages.length === 0) return;
currentIndex = (currentIndex + 1) % sizeGuideImages.length;
updateModalContent();
if (event) event.stopPropagation(); //  Fix: Only call this if event exists
}

function showPrevImage(event) {
if (sizeGuideImages.length === 0) return;
currentIndex = (currentIndex - 1 + sizeGuideImages.length) % sizeGuideImages.length;
updateModalContent();
if (event) event.stopPropagation(); //  Fix: Only call this if event exists
}

function attachEventListeners() {
console.log(" Attaching event listeners...");
document.querySelectorAll(".size-guide-thumbnail").forEach((image) => {
image.removeEventListener("click", openSizeGuideModal);
image.addEventListener("click", openSizeGuideModal);
});
}

attachEventListeners();

closeModal.addEventListener("click", function (event) {
console.log(" Modal closed.");
modal.classList.remove("is-open");
event.stopPropagation();
});

modal.addEventListener("click", function (event) {
if (event.target === modal) {
console.log(" Modal closed by clicking outside.");
modal.classList.remove("is-open");
}
});

prevButton.addEventListener("click", function (event) {
console.log("⬅️ Previous image");
showPrevImage(event);
});

nextButton.addEventListener("click", function (event) {
console.log("➡️ Next image");
showNextImage(event);
});

//  Swipe Functionality
modal.addEventListener("touchstart", function (event) {
startX = event.touches[0].clientX;
});

modal.addEventListener("touchend", function (event) {
endX = event.changedTouches[0].clientX;
handleSwipe();
});

function handleSwipe() {
const swipeThreshold = 50; // Minimum swipe distance in pixels

if (startX - endX > swipeThreshold) {
console.log("➡️ Swiped left, showing next image");
showNextImage();
} else if (endX - startX > swipeThreshold) {
console.log("⬅️ Swiped right, showing previous image");
showPrevImage();
}
}

//  Only add event listener if Shopify actually supports it
if (typeof Shopify !== "undefined" && typeof Shopify.designMode !== "undefined") {
document.addEventListener("shopify:section:load", function () {
console.log(" Shopify section reloaded, reattaching listeners...");
attachEventListeners();
});
} else {
console.log("⚠️ Shopify section event not available, skipping listener.");
}
}); 